export function key(f, descending = false) {
  return (arg0, arg1) => {
    const v0 = f(arg0).toString();
    const v1 = f(arg1).toString();

    return (descending ? -1 : 1) * v0.localeCompare(v1);
  }
}